(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rizon-article-share"] && !Shopify.designMode) return;
  try {
    class RizonArticleShare extends HTMLElement {
    connectedCallback() {
      this.copyButton = this.querySelector('[data-copy-link]');
      this.copyButton?.addEventListener('click', this.copyLink.bind(this));
    }

    copyLink() {
      navigator.clipboard?.writeText(window.location.href);
      if (!this.copyButton) return;
      window.clearTimeout(this.copyLinkTimer);
      this.copyButton.classList.add('is-copied');
      this.copyLinkTimer = window.setTimeout(() => {
        this.copyButton.classList.remove('is-copied');
      }, 2500);
    }
  }
  if (!customElements.get('rizon-article-share')) {
    customElements.define('rizon-article-share', RizonArticleShare);
  }
  } catch(e) { console.error(e); }
})();

})();
